import dayjs from 'dayjs';
import { FC, ReactNode } from 'react';

import { CorporateDetails } from '@/api/corporate/corporate.types.ts';
import CustomGrid from '@/components/controls/CustomGrid.tsx';
import CustomGridLabelValueRow, {
  LabelValueGridRow,
} from '@/components/controls/CustomGridLabelValueRow.tsx';
import { formatZAR } from '@/lib/currency.ts';

type CorporateDetailsGridProps = {
  corporateDetails: CorporateDetails;
};

const CorporateDetailsGrid: FC<CorporateDetailsGridProps> = ({
  corporateDetails,
}: CorporateDetailsGridProps) => {
  const gridData: LabelValueGridRow[] = [
    {
      id: 'companyName',
      label: 'Company Name:',
      value: corporateDetails.companyName,
      rowStyle: 'col-span-1 flex flex-row',
      labelStyle: 'w-1/2 mr-1',
      valueStyle: 'w-1/2',
    },
    {
      id: 'companyRegNo',
      label: 'Company Reg. Number:',
      value: corporateDetails.companyRegNo,
      rowStyle: 'col-span-1 flex flex-row',
      labelStyle: 'w-1/2 mr-1',
      valueStyle: 'w-1/2',
    },
    {
      id: 'contactName',
      label: 'Contact Name:',
      value: `${corporateDetails.name} ${corporateDetails.surname}`,
      rowStyle: 'col-span-1 flex flex-row',
      labelStyle: 'w-1/2 mr-1',
      valueStyle: 'w-1/2',
    },
    {
      id: 'email',
      label: 'Email Address:',
      value: corporateDetails.email,
      rowStyle: 'col-span-1 flex flex-row',
      labelStyle: 'w-1/2 mr-1',
      valueStyle: 'w-1/2 break-all',
    },
    {
      id: 'mobile',
      label: 'Mobile Number:',
      value: corporateDetails.mobileNumber,
      rowStyle: 'col-span-1 flex flex-row',
      labelStyle: 'w-1/2 mr-1',
      valueStyle: 'w-1/2',
    },
    {
      id: 'createdAt',
      label: 'Created At:',
      value: dayjs(corporateDetails.createdAt).format(
        'MMM DD, YYYY [at] HH:mm'
      ),
      rowStyle: 'col-span-1 flex flex-row',
      labelStyle: 'w-1/2 mr-1',
      valueStyle: 'w-1/2',
    },
    {
      id: 'referredBy',
      label: 'Referred By:',
      value: corporateDetails.referredBy,
      rowStyle: 'col-span-1 flex flex-row',
      labelStyle: 'w-1/2 mr-1',
      valueStyle: 'w-1/2',
    },
    {
      id: 'totalSpend',
      label: 'Total Spend:',
      value: formatZAR(corporateDetails.totalSpend || 0),
      rowStyle: 'col-span-1 flex flex-row',
      labelStyle: 'w-1/2 mr-1',
      valueStyle: 'w-1/2',
    },
  ];

  const corporateDetailsGridItem: ReactNode[] = gridData.map((item) => (
    <CustomGridLabelValueRow
      key={item.id}
      id={item.id}
      rowStyle={item.rowStyle}
      label={item.label}
      labelStyle={item.labelStyle}
      value={item.value}
      noValueText="N/A"
      valueStyle={item.valueStyle}
    />
  ));

  return (
    <CustomGrid
      items={corporateDetailsGridItem}
      cols={1}
      gap={6}
      className="mt-4 mb-4"
    />
  );
};

export default CorporateDetailsGrid;
